import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import BrandStyleSheet from "../precheckin/BrandStyleSheet";
import Property from "../../model/property";
import TokenService from "../../backend/TokenService";
import PaymentService from "../../backend/PaymentService.js";
import { get } from "lodash";

class HotelkeyPolling extends Component {
  state = {
    propertyUid: null,
    bookingNumber: null,
    reservation: null,
    hotelkeyPaymentLink: null,
    presets: {},
    countryCode: "US",
    language: "US",
  };

  hotelKeyPaymentTransactionStatus = (
    accessToken,
    paymentTransaction,
    reservationId,
    email,
    type,
    uid
  ) => {
    if (paymentTransaction && reservationId && email && accessToken) {
      PaymentService.getHotelKeyPaymentTransactionStatus(
        accessToken,
        paymentTransaction,
        reservationId,
        email,
        type,
        uid
      )
        .then((response) => {
          if (get(response.data, "status") === "approved") {
            Property.setOrderSuccess(get(response.data, "order"));
            this.goOrderSummary();
          } else if (get(response.data, "status") === "failed") {
            const error = get(response.data, "error");
            console.error(error);
            this.goBack();
          } else {
            setTimeout(() => {
              this.hotelKeyPaymentTransactionStatus(
                accessToken,
                paymentTransaction,
                reservationId,
                email,
                type,
                uid
              );
            }, 3000); // set timer to call the booking api
          }
        })
        .catch((error) => {
          console.error(error);
          // this.goBack()
          throw error;
        });
    }
  };

  async componentDidMount() {
    const language = this.props.i18n.language;
    const propertyUid = Property.getUid();
    const presets = Property.getPreset();
    const reservation = Property.getReservation();
    const hotelkeyPaymentLink = Property.getHotelkeyPaymentLink();
    const email = get(reservation, "payment_link_payer_email");
    const reservationId = get(reservation, "reservation_id");
    const paymentTransaction = get(hotelkeyPaymentLink, "reference");
    const tokenResponse = await TokenService.getProperty(propertyUid);
    const accessToken = get(tokenResponse.data, "access_token");
    const { uid, type } = Property.getOrderInfo();
    this.setState({
      propertyUid,
      language,
      presets,
      reservation,
      hotelkeyPaymentLink,
    });
    this.hotelKeyPaymentTransactionStatus(
      accessToken,
      paymentTransaction,
      reservationId,
      email,
      type,
      uid
    );
  }

  goBack() {
    this.props.history.goBack();
  }

  goOrderSummary() {
    this.props.history.push("/success");
  }

  render() {
    const { presets, property } = this.state;
    const primaryColor =
      (property && property.primary_color) || "rgb(46, 30, 24)";
    const appTopNavBgColor =
      (presets && presets.app_top_nav_bg_color) || primaryColor;
    const appHomeTextTopNav =
      (presets && presets.app_home_text_top_nav) || primaryColor;

    return (
      <>
        <div className="h-full flex flex-col w-full">
          <BrandStyleSheet brandStyleSheet={presets.app_brand_stylesheet} />
          <div className="flex flex-col h-full">
            <section
              id="header"
              className="w-full sticky top-0 z-10">
              <div
                className="flex py-8 px-4 text-white text-left cursor-pointer"
                style={{ backgroundColor: appTopNavBgColor }}
                onClick={() => this.goBack()}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill={appHomeTextTopNav}
                  viewBox="0 0 24 24"
                  stroke="currentColor">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M15 19l-7-7 7-7"
                  />
                </svg>
                <span
                  className="pl-4 type-title large capitalize"
                  style={{ color: appHomeTextTopNav }}>
                  {this.props.t("MAKE_PAYMENT")}
                </span>
              </div>
            </section>

            {this.state.hotelkeyPaymentLink && (
              <section
                id="content"
                className="relative px-9 w-full flex-1 md:flex-0 flex flex-col justify-between h-screen">
                <main
                  className="main container h-full"
                  style={{ marginTop: "15px" }}>
                  <section className="checkout relative h-full">
                    <iframe
                      title="windcave"
                      src={get(this.state.hotelkeyPaymentLink, "payment_link")}
                      frameBorder="0"
                      scrolling="auto"
                      allowFullScreen={true}
                      className="w-full aspect-auto absolute inset-0"
                      width="100%"
                      height="100%"></iframe>
                  </section>
                </main>
              </section>
            )}
          </div>
        </div>
      </>
    );
  }
}

export default withTranslation()(HotelkeyPolling);
